import React from "react";
import { string, bool, func, oneOfType, number } from "prop-types";

import "./radio-button.m.css";

export const RadioButton = ({
  name,
  value,
  checked = false,
  onChange,
  disabled = false,
  className = "",
  ...props
}) => {
  const handleChange = (e) => {
    if (!disabled && onChange) {
      onChange(e);
    }
  };

  return (
    <div styleName="radio-container" className={className}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        styleName="radio-input"
        {...props}
      />
      <span styleName={`radio-custom ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}>
        {checked && <span styleName="radio-dot" />}
      </span>
    </div>
  );
};

RadioButton.propTypes = {
  name: string.isRequired,
  value: oneOfType([string, number]).isRequired,
  checked: bool,
  onChange: func,
  disabled: bool,
  className: string
};